export default __webpack_public_path__ + "static/media/ruby-logo-white.80df5454.svg";